import { Icon } from '@iconify/react/dist/iconify.js';
import React from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import Pagination from './child/Pagination';
import { formatCurrency } from '../helper/currency';
import { useConfirm } from '../context/BootstrapConfirm';
import useErrors from '../hook/useErrors';
import server from '../services/server';

const ProdutosListLayer = ({ data, mutate }) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const currentPage = Number(searchParams.get('page')) || 1;
    const navigate = useNavigate();
    const confirm = useConfirm();
    const { setErrors, toast } = useErrors();

    const handlePageChange = page => {
        setSearchParams({
            ...Object.fromEntries(searchParams),
            page,
        });
    };

    function handleChangeStatus(e) {
        const currentParams = Object.fromEntries(searchParams);
        const newStatus = e.target.value;
        
        if (newStatus === 'true' || newStatus === 'false') {
            currentParams.status = newStatus;
        } else {
            delete currentParams.status; // Remove o parâmetro da URL
        };

        setSearchParams(currentParams);
    };

    function handleChangeName(e) {
        const currentParams = Object.fromEntries(searchParams);


        if (e.target.value.trim().length > 0) {
            currentParams.nome = e.target.value;

        } else {
            delete currentParams.nome;
        }
        setSearchParams(currentParams);
    };


    function handleClick (userId ) {
        navigate(`/produtos/${userId}`)
    }

    function handleClearFilters() {
        setSearchParams({});
    }

    async function handleDelete(e, id) {
        e.stopPropagation();
        try {
            await confirm({
                title: 'Excluir produto',
                message: `Tem certeza que deseja excluir o produto #${id}? Essa ação não pode ser desfeita.`,
                confirmText: 'Excluir',
            });
            await server.delete(`produto/${id}`);
            toast.success('Produto excluído com sucesso!');
            if (typeof mutate === 'function') mutate();
        } catch (error) {
            if (error) setErrors(error);
        }
    }


    return (
        <div className="card h-100 p-0 radius-12">
            <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
                <div className="d-flex align-items-center flex-wrap gap-3">
                    
                    <div className="d-flex flex-wrap align-items-center gap-3">
                        <select className="form-select form-select-sm w-auto" onChange={handleChangeStatus} value={searchParams.get('status') || ''}>
                            <option value="">Todos os status</option>
                            <option value={true}>Ativo</option>
                            <option value={false}>Inativo</option>
                        </select>
                    </div>
                    <form className="navbar-search">
                        <input type="text" className="bg-base h-40-px w-auto" onChange={handleChangeName} name="search" placeholder="Buscar produto" value={searchParams.get('nome') || ''} />
                        <Icon icon="ion:search-outline" className="icon" />
                    </form>
                    <button type="button" className="btn btn-outline-neutral-500 btn-sm" onClick={handleClearFilters}>
                        Limpar
                    </button>
                   
                </div>
                <Link to="add" className="btn btn-primary-600 btn-sm">
                    <Icon icon="ic:baseline-plus" className="icon text-xl line-height-1" />
                    Novo produto
                </Link>
            </div>
            <div className="card-body p-24">
                <div className="table-responsive scroll-sm">
                    <table className="table bordered-table sm-table mb-0">
                        <thead>
                            <tr>
                                <th scope="col">Id</th>
                                <th scope="col">Nome</th>
                                <th scope="col">Valor</th>
                                <th scope="col">Quantidade</th>
                                <th scope="col">Status</th>
                                <th scope="col"> </th>

                            </tr>
                        </thead>
                        <tbody>
                            {Boolean(data) &&
                                data?.map(user => (
                                    <tr onClick={() => handleClick(user.id)}>
                                        <td>{user.id}</td>
                                        <td>
                                            <div className="d-flex align-items-center">
                                               
                                                <div className="flex-grow-1">
                                                    <span className="text-md mb-0 fw-normal text-secondary-light">{user.nome}</span>
                                                </div>
                                            </div>
                                        </td>
                                     
                                        <td>{formatCurrency(user.valor)}</td>
                                        <td>{user.estoque ?? 'Não informado'}</td>

                                        <td>
                                           
                                            {(() => {
                                                const isActive = user.status === true;
                                                const style = isActive ? 'success' : 'danger';
                                                const text = isActive ? 'Ativo' : 'Inativo';

                                                return (
                                                    <span
                                                        className={`bg-${style}-focus rounded-pill text-sm text-${style}-main fw-medium px-24 py-4`}
                                                    >
                                                        {text}
                                                    </span>
                                                );
                                            })()}
                                        </td>

                                        <td className="text-center">
                                            <div className="d-flex align-items-center gap-10 justify-content-center">

                                                <Link
                                                    to={`${user.id}`}
                                                    className="bg-success-focus text-success-600 bg-hover-success-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                >
                                                    <Icon icon="lucide:edit" className="menu-icon" />
                                                </Link>
                                                <button
                                                    type="button"
                                                    title="Excluir produto"
                                                    onClick={(e) => handleDelete(e, user.id)}
                                                    className="bg-danger-focus text-danger-600 bg-hover-danger-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle border-0"
                                                >
                                                    <Icon icon="mingcute:delete-2-line" className="menu-icon" />
                                                </button>

                                            </div>
                                        </td>

                                    </tr>
                                ))}
                        </tbody>
                    </table>
                </div>
                <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mt-24">
                    <span> Mostrando {data?.itens_per_page} de{' '} {data?.total}  {data?.itens_per_page > 1 ? "itens" : "item"}  </span>
                    {data?.pages > 1 && <Pagination page={data.currentPage} pages={data?.pages} onPageChange={handlePageChange}  />}
                </div>
            </div>
        </div>
    );
};

export default ProdutosListLayer;
